import { render } from "./EditClaimEvent.vue?vue&type=template&id=cce331ca&scoped=true"
import script from "./EditClaimEvent.vue?vue&type=script&lang=js"
export * from "./EditClaimEvent.vue?vue&type=script&lang=js"

import "./save-claim-event.scss?vue&type=style&index=0&id=cce331ca&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\hrportal\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cce331ca"]])

export default __exports__